import Layout from '@/layout'

const route = {
  path: '/massiveAdvertisingAD/list',
  component: Layout,
  redirect: '/massiveAdvertisingAD/list',
  alwaysShow: true, // will always show the root menu
  name: 'massiveAdvertisingADList',
  meta: {
    title: '巨量3.0',
    icon: 'business',
    roles: [
      'ocean'
    ]
  },
  children: [
    {
      path: '/massiveAdvertisingAD/accountAD/index',
      component: () => import('@/views/massiveAdvertisingAD/accountList/index.vue'),
      name: 'massiveAdvertisingADaccountAD',
      meta: {
        title: '账户列表',
        icon: 'component',
        roles: [
          'ocean.advertiser.ocean_accounts'
        ]
      }
    },
    {
      path: '/accountdetection/index',
      component: () => import('@/views/accountdetection/index.vue'),
      name: 'massiveAdvertisingADaccountAD',
      meta: {
        title: '账号报表监测通知',
        icon: 'component',
        roles: [
          'ocean.auth_user.list'
        ]
      }
    },
    // {
    //   path: '/massiveAdvertisingAD/WeChatAccount/index',
    //   component: () => import('@/views/massiveAdvertisingAD/WeChatAccount/index.vue'),
    //   name: 'tencentWeChatAccount',
    //   meta: {
    //     title: '授权账户',
    //     icon: 'component',
    //     roles: [
    //       'advertisers.index'
    //     ]
    //   }
    // },
    {
      path: '/massiveAdvertisingAD/project/index',
      component: () => import('@/views/massiveAdvertisingAD/project/index.vue'),
      name: 'massiveAdvertisingADproject',
      meta: {
        title: '项目',
        icon: 'component',
        roles: [
          'ocean.account.project.index'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/adList/index',
      component: () => import('@/views/massiveAdvertisingAD/ADlist/index.vue'),
      name: 'massiveAdvertisingADadList',
      meta: {
        title: '广告',

        roles: [
          'ocean.account.promotion.index'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/backhaul/index',
      component: () => import('@/views/backhaul/index.vue'),
      name: 'massiveAdvertisingADbackhaul',
      meta: {
        title: '回传配置',

        roles: [
          'ocean.report.rule_list'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/monitor_link/index',
      component: () => import('@/views/monitorLink/index.vue'),
      name: 'massiveAdvertisingADMonitorLink',
      meta: {
        title: '监测链接',

        roles: [
          'ocean.report.monitor_link_list'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/copyRecord/index',
      component: () => {
        return import('@/views/massiveAdvertisingAD/copyRecord/index.vue')
      },
      name: 'massiveAdvertisingADcopyRecord',
      meta: {
        title: '复制记录',

        roles: [
          'ocean.copy.job_list'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/copychameleon/index',
      component: () => {
        return import('@/views/massiveAdvertisingAD/copychameleon/index.vue')
      },
      name: 'massiveAdvertisingADcopyRecord',
      meta: {
        title: '复制记录(变色龙)',

        roles: [
          'ocean.copy_v2.job_list'
        ]
      }
    },
    {
      path: '/getCopyQueueJL/getCopyQueueJL/index',
      component: () => import('@/views/adCopyJL/getCopyQueue/index.vue'),
      name: 'copyQueue',
      meta: {
        title: '复制队列',
        icon: 'component',
        roles: [
          'ocean.copy_v2.get_copy_queue'
        ]
      }
    },
    {
      path: '/wechatQueueJL/getCopypath/index',
      component: () => import('@/views/getCopypath/index.vue'),
      name: 'copyQueue',
      meta: {
        title: '小程序链接',
        icon: 'component',
        roles: [
          'ocean.copy_v2.url_list'
        ]
      }
    },
    {
      path: '/massiveAdvertisingAD/property/index',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      name: 'copyRecordIndex',
      meta: {
        title: '素材',

        roles: [
          'ocean.material'
        ]
      },
      children: [
        {
          path: '/massiveAdvertisingAD/property/img',
          component: () => {
            return import('@/views/massiveAdvertisingAD/property/imageList.vue')
          },
          name: 'propertyImg',
          meta: {
            title: '素材图片',

            roles: [
              'ocean.material.image.list'
            ]
          }
        },
        {
          path: '/massiveAdvertisingAD/property/video',
          component: () => {
            return import('@/views/massiveAdvertisingAD/property/videoList.vue')
          },
          name: 'propertyVideo',
          meta: {
            title: '素材视频',

            roles: [
              'ocean.material.video.list'
            ]
          }
        },
        {
          path: '/massiveAdvertisingAD/miniAd/index',
          component: () => import('@/views/massiveAdvertisingAD/miniAd/index.vue'),
          name: 'miniAd',
          meta: {
            title: '短剧广告',
            icon: 'componet',
            roles: [
              'adx_task_center'
            ]
          }
        }
        // {
        //   path: '/massiveAdvertisingAD/property/danmu',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/barrageList.vue')
        //   },
        //   name: 'propertyDanmu',
        //   meta: {
        //     title: '素材弹幕',
        //
        //     roles: [
        //       'ad_management.account_v3.material_barrage.list'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/brand',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/brandList.vue')
        //   },
        //   name: 'propertyBrand',
        //   meta: {
        //     title: '品牌形象',
        //
        //     roles: [
        //       'ad_management.account_v3.material_brand.list'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/skip',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/skipList.vue')
        //   },
        //   name: 'propertySkip',
        //   meta: {
        //     title: '朋友圈头像昵称跳转页',
        //
        //     roles: [
        //       'ad_management.account_v3.material_profiles.list'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/pages',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/pagesList.vue')
        //   },
        //   name: 'propertyPages',
        //   meta: {
        //     title: '原生落地页',
        //
        //     roles: [
        //       'ad_management.account_v3.material_wechat_pages.lis'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/assetsList',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/assetsList.vue')
        //   },
        //   name: 'propertyAssetsList',
        //   meta: {
        //     title: '可投放推广内容资产',
        //
        //     roles: [
        //       'ad_management.account_v3.material_marketing_target'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/landing_page_sell_strategy',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/landingPageSellStrategy.vue')
        //   },
        //   name: 'LandingPageSellStrategy',
        //   meta: {
        //     title: '短剧售卖策略',
        //
        //     roles: [
        //       'ad_management.account_v3.material_marketing_target'
        //     ]
        //   }
        // },
        // {
        //   path: '/massiveAdvertisingAD/property/feedback_info',
        //   component: () => {
        //     return import('@/views/massiveAdvertisingAD/property/feedbackInfo.vue')
        //   },
        //   name: 'FeedbackInfo',
        //   meta: {
        //     title: '监测链接组',
        //
        //     roles: [
        //       'ad_management.account_v3.material_marketing_target'
        //     ]
        //   }
        // }
      ]
    },
    {
      path: '/massiveAdvertisingAD/oceanSetup/index',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      name: 'oceanSetup',
      meta: {
        title: '极速搭建',

        roles: [
          'ocean.setup'
        ]
      },
      children: [
        {
          path: '/massiveAdvertisingAD/AdvertisingTemplate/index',
          component: () => {
            return import('@/views/massiveAdvertisingAD/AdvertisingTemplate/index.vue')
          },
          name: 'AdvertisingTemplate',
          meta: {
            title: '广告模版管理',
            roles: [
              'ocean.setup_template'
            ]
          }
        },
        {
          path: '/massiveAdvertisingAD/addAdvertisingTemplate/index',
          component: () => {
            return import('@/views/massiveAdvertisingAD/AdvertisingTemplate/addAdTemplate.vue')
          },
          name: 'addAdvertisingTemplate',
          meta: {
            title: '设置广告模版',
            roles: [
              'ocean.setup_template'
            ]
          },
          hidden: true
        },
        {
          path: '/massiveAdvertisingAD/AudienceTargeting/index',
          component: () => {
            return import('@/views/massiveAdvertisingAD/AudienceTargeting/index.vue')
          },
          name: 'AudienceTargeting',
          meta: {
            title: '定向包管理',
            roles: [
              'ocean.setup_audience_package'
            ]
          }
        },
        {
          path: '/massiveAdvertisingAD/AdvertisingJob/index',
          component: () => {
            return import('@/views/massiveAdvertisingAD/AdvertisingJob/index.vue')
          },
          name: 'AdvertisingJob',
          meta: {
            title: '任务列表',
            roles: [
              'ocean.setup_job'
            ]
          }
        },
        {
          path: '/massiveAdvertisingAD/AdvertisingAddJob/index',
          component: () => {
            return import('@/views/massiveAdvertisingAD/AdvertisingJob/addJob.vue')
          },
          name: 'AdvertisingAddJob',
          meta: {
            title: '新增任务',
            roles: [
              'ocean.setup_job'
            ]
          },
          hidden: true
        }
      ]
    }
    // {
    //   path: '/massiveAdvertisingAD/wechatAuthorization/index',
    //   component: () => import('@/views/messageTemplate/index.vue'),
    //   name: 'wechatAuthorization',
    //   meta: {
    //     title: '微信生态授权管理',
    //     icon: 'component',
    //     roles: [
    //       'adq_mkt_api_auth'
    //     ]
    //   },
    //   children: [
    //     {
    //       path: '/massiveAdvertisingAD/authorizationInof/index',
    //       component: () => {
    //         return import('@/views/massiveAdvertisingAD/authorizationInof/index.vue')
    //       },
    //       name: 'authorizationInof',
    //       meta: {
    //         title: '授权信息',
    //
    //         roles: [
    //           'adq_mkt_api_auth.manage'
    //         ]
    //       }
    //     },
    //     {
    //       path: '/massiveAdvertisingAD/authorizationAccount/index',
    //       component: () => {
    //         return import('@/views/massiveAdvertisingAD/authorizationAccount/index.vue')
    //       },
    //       name: 'authorizationAccount',
    //       meta: {
    //         title: '授权账户',
    //
    //         roles: [
    //           'adq_mkt_api_auth.account'
    //         ]
    //       }
    //     }
    //   ]
    // }
  ]
}

export default route
